import SocialMedia from "components/About/SocialMedia";
import LatestWorkshop from "components/Homepage/LatestWorkshop";
import PriceSection from "components/Service/PriceSection";
import HeroTrainingBusiness from "components/TrainingBusiness/HeroTrainingBusiness";
import ListTrainingBusiness from "components/TrainingBusiness/ListTrainingBusiness";
import MissionTraining from "components/TrainingBusiness/MissionTraining";
import QuoteTrainingBusiness from "components/TrainingBusiness/QuoteTrainingBusiness";
import React, { useEffect } from "react";
import BookSection from "components/Events/BookSection";
import { useLocation } from "react-router-dom";

const TrainingBusiness = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");

      setTimeout(() => {
        const element = document.getElementById(id);

        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }
  }, [location]);
  return (
    <div>
      {/* <HeroTrainingBusiness /> */}
      <MissionTraining />
      <QuoteTrainingBusiness />
      <div id="trainingcoaching">
        <ListTrainingBusiness />
      </div>
      <BookSection />
    </div>
  );
};

export default TrainingBusiness;
